import React from 'react'
import '../../styles/Expertise/Expertise3D.css'
import { Accordion, Col, Row } from 'react-bootstrap'
import { Fade } from 'react-awesome-reveal'
import AccordionText from '../Utils/AccordionText'
import expertise3DSection2 from '../../assets/expertise/expertise-plan-3D-section2.jpg'
import { BrowserView, MobileView } from 'react-device-detect'
import { Helmet } from 'react-helmet'

function Expertise3D() {

    const section1AccordionData = [
        {
            title: "Visualisation améliorée :",
            text: "La représentation en 3D offre une compréhension claire de la conception spatiale, permettant de mieux appréhender les volumes, les textures, et l’interaction des différents éléments."
        }, {
            title: "Prise de décision facilitée :",
            text: "Grâce à une vision réaliste du projet, les décideurs peuvent évaluer les options de design, ajuster les plans et apporter des modifications avant le début des travaux, réduisant ainsi les coûts de modifications ultérieures."
        }, {
            title: "Communication efficace :",
            text: "Les plans en 3D facilitent la communication entre tous les intervenants du projet, en fournissant une base commune de compréhension et en limitant les interprétations erronées."
        }, {
            title: "Marketing renforcé :",
            text: "Pour les projets de vente ou de location, les visuels 3D servent d’outils de marketing puissants, attirant l’attention des clients potentiels et aidant à concrétiser les transactions."
        }
    ]

    const section2AccordionData = [
        {
            title: "1. Relevé précis :",
            text: "Notre première étape consiste à réaliser un relevé détaillé du bien existant ou à travailler à partir de plans architecturaux pour les nouveaux projets."
        }, {
            title: "2. Création du modèle numérique :",
            text: "Nous utilisons des logiciels de modélisation 3D de pointe pour transformer les plans cotés en un modèle tridimensionnel, intégrant tous les aspects du design."
        }, {
            title: "3. Personnalisation :",
            text: "Le modèle 3D est ensuite personnalisé selon vos préférences, avec le choix des matériaux, des couleurs, et des finitions, pour correspondre exactement à votre vision."
        }, {
            title: "4. Rendu final :",
            text: "Nous produisons des rendus 3D haute définition qui mettent en valeur le projet sous différents angles, offrant une immersion complète dans le design proposé."
        }
    ]

    return (

        <>
            <Helmet>
                <meta name="title" content="Mise en élévation des plans en 3D - E5M Diagnostics" />
                <meta name="description" content="Mise en élévation des plans en 3D sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:title" content="Mise en élévation des plans en 3D - E5M Diagnostics" />
                <meta property="og:description" content="Mise en élévation des plans en 3D sur Paris et Île-de-France lors de la vente ou de la mise en location de vos biens immobiliers." />
                <meta property="og:url" content="https://www.e5mdiagnostics.fr/plans-élévation-3D" />
                <link rel="canonical" href="https://www.e5mdiagnostics.fr/plans-élévation-3D" />
            </Helmet>

            <BrowserView>
                <div id='expertise3D'>
                    <div id='header'>
                        <div id='expertise3DHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilter'>
                                    <h1 id='headerFilterTitle'>Mise en élévation des plans en 3D</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <Row id='expertise3DSection1'>
                        <Col>
                            <Fade direction={'left'} duration={500}>
                                <div id='expertise3DSection1Left'>
                                    <div className='sectionText'>
                                        Même si les plans bidimensionnels (2D) constituent toujours le standard réglementaire pour les transactions immobilières, ils peuvent s’avérer insuffisants pour captiver l’attention des acheteurs actuels, qui, davantage exposés aux
                                        médias visuels, privilégient les représentations plus concrètes et informatives. Les futurs propriétaires apprécient particulièrement la possibilité de visualiser l’espace et de comprendre précisément ce qu’ils envisagent d’acquérir.
                                    </div>
                                    <div className='sectionText'>
                                        Pour répondre à cette attente croissante, nous offrons des services de modélisation en trois dimensions (3D) pour présenter votre futur appartement sous un angle nouveau et plus attrayant. Ces plans 3D constituent une méthode innovante
                                        et efficace, offrant aux acquéreurs une expérience immersive et détaillée de leur potentiel futur espace de vie.
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <div id='expertise3DSection1Right'>
                                    <div className='sectionTitle'>Avantages de la modélisation 3D</div>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section1AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <Row id='expertise3DSection2'>
                        <Col>
                            <Fade direction={'right'} duration={500}>
                                <div id='expertise3DSection2Left'>
                                    <h1 className='sectionTitle'>Processus de Mise en Élévation 3D chez E5M Diagnostics</h1>
                                    <div className='sectionAccordionDark'>
                                        <Accordion>
                                            {section2AccordionData.map((item, index) => {
                                                return (
                                                    <AccordionText
                                                        key={index}
                                                        indexKey={index}
                                                        header={item.title}
                                                        body={item.text}
                                                    />
                                                )
                                            })}
                                        </Accordion>
                                    </div>
                                </div>
                            </Fade>
                        </Col>
                        <Col>
                            <Fade direction={'right'} duration={500} delay={100}>
                                <div id='expertise3DSection2Right'>
                                    <img src={expertise3DSection2} id='expertise3DSection2Image' alt='expertise-3D-section2' />
                                </div>
                            </Fade>
                        </Col>
                    </Row>
                    <div id='expertise3DSection3'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitle'>Pourquoi Choisir E5M Diagnostics ?</h1>
                            <div className='sectionText'>
                                Nous combinons expertise technique et créativité pour offrir des services de modélisation 3D qui transcendent les attentes. Notre approche personnalisée garantit que chaque projet bénéficie d’une attention particulière, adaptée à ses
                                spécificités et à ses besoins uniques. Que vous soyez à l’étape de la conception, de la rénovation ou de la commercialisation, notre équipe est là pour transformer vos idées en réalités visuelles impressionnantes.
                            </div>
                            <div className='sectionText'>
                                La mise en élévation des plans en 3D est une révolution dans le domaine de la construction et de l’immobilier, permettant une planification plus précise, une exécution plus efficace et une commercialisation plus dynamique de vos projets.
                                Avec E5M Diagnostics, franchissez le pas vers l’avenir de la visualisation architecturale.
                            </div>
                        </Fade>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div id='expertise3D'>
                    <div id='header'>
                        <div id='expertise3DHeader' className='headerBackground'>
                            <Fade direction={'down'} duration={500}>
                                <div id='headerFilterMobile'>
                                    <h1 id='headerFilterTitleMobile'>Mise en élévation des plans en 3D</h1>
                                </div>
                            </Fade>
                        </div>
                    </div>
                    <div id='expertise3DSection1Mobile' className='sectionDarkMobile'>
                        <Fade direction={'left'} duration={500}>
                            <div className='sectionTextMobile'>
                                Même si les plans bidimensionnels (2D) constituent toujours le standard réglementaire pour les transactions immobilières, ils peuvent s'avérer insuffisants pour captiver l'attention des acheteurs actuels, qui, davantage exposés aux
                                médias visuels, privilégient les représentations plus concrètes et informatives. Les futurs propriétaires apprécient particulièrement la possibilité de visualiser l'espace et de comprendre précisément ce qu'ils envisagent d'acquérir.
                            </div>
                            <div className='sectionTextMobile'>
                                Pour répondre à cette attente croissante, nous offrons des services de modélisation en trois dimensions (3D) pour présenter votre futur appartement sous un angle nouveau et plus attrayant. Ces plans 3D constituent une méthode innovante
                                et efficace, offrant aux acquéreurs une expérience immersive et détaillée de leur potentiel futur espace de vie.
                            </div>
                            <div className='sectionTitleMobile'>Avantages de la modélisation 3D</div>
                            <div className='sectionAccordionDark sectionAccordionMobile'>
                                <Accordion>
                                    {section1AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                        </Fade>
                    </div>
                    <div id='expertise3DSection2Mobile'>
                        <Fade direction={'right'} duration={500}>
                            <h1 className='sectionTitleMobile'>Processus de Mise en Élévation 3D chez E5M Diagnostics</h1>
                            <div className='sectionAccordionMobile'>
                                <Accordion>
                                    {section2AccordionData.map((item, index) => {
                                        return (
                                            <AccordionText
                                                key={index}
                                                indexKey={index}
                                                header={item.title}
                                                body={item.text}
                                            />
                                        )
                                    })}
                                </Accordion>
                            </div>
                            <img src={expertise3DSection2} id='expertise3DSection2ImageMobile' alt='expertise-3D-section2' />
                        </Fade>
                    </div>
                    <div id='expertise3DSection3Mobile'>
                        <Fade direction={'left'} duration={500}>
                            <h1 className='sectionTitleMobile'>Pourquoi Choisir E5M Diagnostics ?</h1>
                            <div className='sectionTextMobile'>
                                Nous combinons expertise technique et créativité pour offrir des services de modélisation 3D qui transcendent les attentes. Notre approche personnalisée garantit que chaque projet bénéficie d'une attention particulière, adaptée à ses
                                spécificités et à ses besoins uniques. Que vous soyez à l'étape de la conception, de la rénovation ou de la commercialisation, notre équipe est là pour transformer vos idées en réalités visuelles impressionnantes.
                            </div>
                            <div className='sectionTextMobile'>
                                La mise en élévation des plans en 3D est une révolution dans le domaine de la construction et de l'immobilier, permettant une planification plus précise, une exécution plus efficace et une commercialisation plus dynamique de vos projets.
                                Avec E5M Diagnostics, franchissez le pas vers l'avenir de la visualisation architecturale.
                            </div>
                        </Fade>
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default Expertise3D